import React, {useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import splash from '../splash.gif'

const SplashScreen = ()=>{
    const navigate = useNavigate();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            navigate("/Home");
        }, 3000);

        // Cleanup function to clear the timeout if the component unmounts
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
}}>
            <img src={splash} alt='splash screen' style={{width:"300px"}}></img>
        </div>
    );
}

export default SplashScreen;